<template>
  <div class="message-main">
    <div class="table">
      <div class="table-header">
        <div class="table-header-date">
          日付
        </div>

        <div class="table-header-user-id">
          ユーザー名
        </div>

        <div class="table-header-content">
          内容
        </div>
      </div>

      <div
        v-for="(message, index) in messages"
        :key="index"
        class="table-cell"
        @click="editMessage(message)"
        >

        <div class="table-cell-date">
          {{ sentDate(message) }}
        </div>

        <div class="table-cell-user-id">
          <link-edit-user :model="message" />
        </div>

        <div class="table-cell-content">
          {{ message.get('content') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { format } from 'date-fns'
import LinkEditUser from '@/components/User/LinkEditUser'

export default {
  components: {
    LinkEditUser
  },

  computed: {
    ...mapState('message', [
      'messages'
    ])
  },

  methods: {
    editMessage: function (message) {
      this.$router.push({
        name: 'message-edit',
        params: { id: message.id }
      })
    },

    sentDate: function (message) {
      const date = message.get('date')
      if (date) {
        return format(date, 'YYYY/M/D H:mm')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin cell {
  &-date {
    padding: 5px;
    width: 25%;
  }

  &-user-id {
    padding: 5px;
    width: 15%;
  }

  &-content {
    padding: 5px;
    width: 60%;
  }
}

@import '@/styles/_table.scss';
</style>
